var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17801_2110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.75004V8.62504L15.3334 4.79171L11.5 0.958374V3.83337C7.26421 3.83337 3.83337 7.26421 3.83337 11.5C3.83337 13.0046 4.27421 14.399 5.02171 15.5825L6.42087 14.1834C5.99442 13.3832 5.75004 12.4727 5.75004 11.5C5.75004 8.32316 8.32317 5.75004 11.5 5.75004ZM17.9784 7.41754L16.5792 8.81671C17.0057 9.61691 17.25 10.5273 17.25 11.5C17.25 14.6769 14.6769 17.25 11.5 17.25V14.375L7.66671 18.2084L11.5 22.0417V19.1667C15.7359 19.1667 19.1667 15.7359 19.1667 11.5C19.1667 9.99546 18.7259 8.60108 17.9784 7.41754Z",
    fill: "#667085",
    stroke: "white",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17801_2110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.32a3ac94d6d2fbe0d894393cd76cec29.svg";
export { ForwardRef as ReactComponent };